const region = process.env.VUE_APP_SITE_REGION || 'cn';

export const siteConfig = {
  region,
  isCn: region === 'cn',
  hostLabel: region === 'cn' ? 'TaiyiPan.cn' : 'TaiyiPan.com',
  supportEmail: 'contact@taiyipan.com',
  records: {
    icp: '豫ICP备2023021170号-2',
    public: '豫公网安备41038102000315号'
  }
};
